import React, { ReactNode } from 'react';
import { AuthProvider } from './auth.context';
import { LoaderProvider } from './pharmaceutical-portal/Loader.context';
import { AlertProvider } from './pharmaceutical-portal/Alert.context';
import { RoutesProvider } from './routes.context';
import { DialogueProvider } from './pharmaceutical-portal/Dialogue.context';

export type AppContextProps = {
  children: ReactNode;
};

export default function AppContext({ children }: AppContextProps): JSX.Element {
  return (
    <AuthProvider>
      <LoaderProvider>
        <AlertProvider>
          <DialogueProvider> 
            <RoutesProvider>{children}</RoutesProvider>
          </DialogueProvider>
        </AlertProvider>
      </LoaderProvider>
    </AuthProvider>
  );
}
